import React from 'react';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import Ionicons from 'react-native-vector-icons/Ionicons';
import { useTheme } from '../context/ThemeContext';
import { getThemeColors } from '../utils/themeStyles';

// État d'erreur réseau/service réutilisable, avec bouton "Réessayer".
// Affiche un spinner sur le bouton tant qu'un nouvel essai est en cours.
export default function ErrorRetry({
  onRetry,
  retrying = false,
  message = 'Impossible de charger les données. Vérifiez votre connexion.',
}: {
  onRetry: () => void;
  retrying?: boolean;
  message?: string;
}) {
  const { isDarkTheme } = useTheme();
  const colors = getThemeColors(isDarkTheme);
  return (
    <View style={styles.wrap}>
      <Ionicons name="cloud-offline-outline" size={44} color={colors.textTertiary} />
      <Text style={[styles.msg, { color: colors.textSecondary }]}>{message}</Text>
      <TouchableOpacity
        style={[styles.btn, { backgroundColor: colors.primary, opacity: retrying ? 0.7 : 1 }]}
        onPress={onRetry}
        disabled={retrying}
      >
        {retrying ? (
          <ActivityIndicator size="small" color={colors.badgeText} />
        ) : (
          <Ionicons name="refresh" size={16} color={colors.badgeText} />
        )}
        <Text style={[styles.btnText, { color: colors.badgeText }]}>Réessayer</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { alignItems: 'center', justifyContent: 'center', paddingVertical: 48, gap: 12 },
  msg: { fontSize: 14, textAlign: 'center', paddingHorizontal: 24, lineHeight: 20 },
  btn: { flexDirection: 'row', alignItems: 'center', gap: 8, paddingHorizontal: 18, paddingVertical: 10, borderRadius: 8 },
  btnText: { fontSize: 14, fontWeight: '600' },
});
